import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

import { getVerificationRedirectData } from '@/lib/redirect-utils'
import { redirectTo } from '@/lib/route-utils'
import { Routes } from '@/lib/routes'
import { WorldlineOrderStatus, WorldlineStatus } from '@/travelsuit/worldline'

import { OrderVerificationDataState } from './order-verification-utils'

const STATUS = 'statusCode'

type RouteParams = {
	orderId: string
}

export function OrderCallbackVerification() {
	const params = useParams<RouteParams>()
	const location = useLocation()

	const { search } = location

	const navigate = useNavigate()

	const redirectBack = () => {
		const redirectData = getVerificationRedirectData<{ trip_id?: number }>()

		const searchParams = new URLSearchParams(search)
		const status = searchParams.get(STATUS) as WorldlineStatus
		const isAccepted =
			searchParams.has('accepted') || [WorldlineStatus.APPROVED, WorldlineOrderStatus.Captured].includes(status)

		let verificationData: Partial<OrderVerificationDataState> = {
			order_id: params.orderId,
		}

		if (isAccepted) {
			verificationData = {
				...verificationData,
				worldline_validated: true,
			}
			if (redirectData?.data?.trip_id) {
				verificationData.trip_id = redirectData.data.trip_id
			}
		} else {
			verificationData = {
				...verificationData,
				worldline_validated: false,
			}
		}

		if (redirectData?.returnToUrl) {
			navigate(redirectData.returnToUrl, { state: verificationData })
		} else {
			redirectTo(Routes.Home)
		}
	}

	React.useEffect(() => {
		redirectBack()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return null
}
